import React, { useEffect } from "react";

const Hotjar: React.FC = () => {
  useEffect(() => {
    if (process.env.GATSBY_HOTJAR_ENABLED === "false") {
      return null;
    }
    const scriptTag = document.createElement("script");
    scriptTag.innerHTML = `(function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:1982272,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
    document.getElementsByTagName("head")[0].appendChild(scriptTag);
  }, []);
  return <></>;
};

export default Hotjar;
